import { HomeOutlined } from '@ant-design/icons';
import { Breadcrumb } from 'antd';
import { truncate } from 'lodash';
import type * as React from 'react';
import { useTranslation } from 'react-i18next';
import { down } from 'styled-breakpoints';
import { useBreakpoint } from 'styled-breakpoints/react-styled';
import styled from 'styled-components';
import { type BrandedPath, Link } from '../TypedRoute.tsx';
import { useBreadcrumbs } from './BreadcrumbContext.tsx';

const BreadcrumbStyled = styled(Breadcrumb)`
  .ant-breadcrumb-link > a {
    color: rgba(0, 0, 0, 0.88);
    text-decoration: ${({ theme }) => theme.breadcrumbTextDecoration};
    cursor: pointer;
    &:hover {
      color: rgba(0, 0, 0, 0.88);
      text-decoration: underline;
    }
  }
  .ant-breadcrumb-separator {
    color: rgba(0, 0, 0, 0.66);
  }
`;
const getDesiderateLength = (areFew?: boolean) => {
  return areFew ? 90 : 45;
};
const textForAria = (title: React.ReactNode, areFew?: boolean) => {
  const length = getDesiderateLength(areFew);
  return typeof title === 'string' && title.length > length ? title : undefined;
};
const truncateTitle = (title: React.ReactNode, areFew?: boolean) => {
  const length = getDesiderateLength(areFew);
  return typeof title === 'string' ? truncate(title, { length }) : title;
};

export interface IBreadcrumbsProps {}

// TODO prompt per prevenire la perdita in caso di pressione accidentale durante l'edit
/**
 * Componente che visualizza l'elenco dei breadcrumb registrati.
 */
export function Breadcrumbs(props: IBreadcrumbsProps) {
  const items = useBreadcrumbs();
  const { t } = useTranslation();
  const isMobile = useBreakpoint(down('sm'));

  // se ci sono pochi elementi facciamo il titolo più lungo
  const areFew: boolean = items.length < (isMobile ? 2 : 3);

  const breadcrumbItems = [
    {
      title: (
        <Link
          to={'/' as BrandedPath}
          aria-label={t('router.breadcrumbs.home-aria', 'Home')}
        >
          <HomeOutlined aria-hidden />
        </Link>
      ),
    },
    ...items.map((b, i) => {
      return {
        key: b.path ?? b.key,
        title:
          b.path !== undefined && items.length - 1 !== i ? (
            <Link title={textForAria(b.title, areFew)} to={b.path}>
              {truncateTitle(b.title, areFew)}
            </Link>
          ) : (
            <span title={textForAria(b.title, areFew)}>
              {truncateTitle(b.title, areFew)}
            </span>
          ),
      };
    }),
  ];

  return <BreadcrumbStyled items={breadcrumbItems} />;
}
